import React from 'react'
import { useDropzone } from 'react-dropzone'
import PropTypes from 'prop-types'
import { useField } from 'formik'
import { FormFeedback, Spinner } from 'reactstrap'
import UploadPhotoIcon from 'components/atoms/upload-photo-icon/upload-photo-icon'

const propTypes = {
  className      : PropTypes.string,
  style          : PropTypes.object,
  isMultiple     : PropTypes.bool,
  isLoading      : PropTypes.bool,
  onDrop         : PropTypes.func.isRequired,
  onClickRemove  : PropTypes.func.isRequired,
  placeholderImg : PropTypes.string,
  disabled       : PropTypes.bool
}

/**
 *
 * @param {*} param0
 * @returns
 */
const FastSellImageUploadFIeld = ({
  className = '',
  style = {},
  isMultiple = false,
  isLoading = false,
  onDrop,
  onClickRemove,
  placeholderImg,
  disabled,
  ...props
}) => {

  const [ field, meta ] = useField(props)

  const invalid = meta.touched && !!meta.error

  const { getRootProps, getInputProps } = useDropzone({
    accept   : 'image/jpeg, image/png',
    onDrop   : onDrop,
    multiple : isMultiple
  })

  // pass the image object to the callback
  const handleClickRemove = () => {
    onClickRemove(field.value)
  }

  // some image models use url instead of s3_url
  const image           = field.value
  const isImageUploaded = (image?.s3_url || image?.url)

  return (
    <div { ...getRootProps({
      className,
      style: {
        ...style,
        cursor: 'pointer'
      }
    }) }
    >
      {
        // display image.url
        isImageUploaded && (
          <>
            <i
              onClick={ handleClickRemove }
              className='fas fa-times-circle position-absolute p-2 fa-lg'
              style={{ top: 9, right: 15 }}
            />
            <img
              src={ field.value.s3_url }
              className='img-fluid'
            />
          </>
        )
      }
      {
        // defined placeholder image or default placeholder
        !isImageUploaded && (
          <>
            <input
              type="file"
              disabled={ disabled }
              { ...getInputProps() }
            />
            {
              isLoading
                ? (
                  <Spinner
                    className='position-absolute'
                    style={{ top: 9, right: 15 }}
                  />
                )
                : (
                  <i
                    className='fas fa-plus position-absolute p-2 fa-lg'
                    style={{ top: 9, right: 15 }}
                  />
                )
            }
            {
              placeholderImg
                ? <img className='w-100' src={ placeholderImg } />
                : (
                  <div
                    className='d-flex justify-content-center align-items-center border-primary'
                    style={{
                      border        : '1px dotted',
                      height        : '100px',
                      verticalAlign : 'middle'
                    }}
                  >
                    <UploadPhotoIcon
                      fill={ 'gray' }
                      width={ '80px' }
                      height={ '80px' }
                    />
                  </div>
                )
            }
          </>
        )
      }
      { invalid && <FormFeedback className={ 'd-block' }>{ meta.error?.s3_url }</FormFeedback> }
    </div>
  )
}

FastSellImageUploadFIeld.propTypes = propTypes

export default FastSellImageUploadFIeld
